export default ['JsonRPCService', 'claim.endpointConfig', (JsonRPCService, endpointConfig) => {
    return {
        removeDocument: (claimNumber, publicID) => {
            return JsonRPCService.send('cc', endpointConfig.documentsEndpoint, 'removeDocument', [claimNumber, publicID]);
        }
    };
}];